import { useLayoutEffect, useSyncExternalStore } from 'react';
import { useLocation } from 'react-router-dom';
import { getTheme, initializeTheme, setTheme, subscribeTheme, toggleTheme } from './theme';
import 'pretendard/dist/web/variable/pretendardvariable-dynamic-subset.css';
import './tokens.css';
import './admin-compat.css';
import './admin-tabs.css';
import './admin-search.css';
import './admin-modals.css';

export function useTheme() {
  const theme = useSyncExternalStore(subscribeTheme, getTheme, () => 'dark');
  return { theme, setTheme, toggleTheme };
}

export function useAdminThemeScope() {
  const { pathname } = useLocation();
  const isAdmin = /^\/(?:admin|admin_main)(?:\/|$)/.test(pathname);
  useLayoutEffect(() => {
    const root = document.documentElement;
    if (!isAdmin) {
      root.removeAttribute('data-admin-design');
      root.removeAttribute('data-theme');
      return;
    }
    root.setAttribute('data-admin-design', '');
    initializeTheme();
    return () => {
      root.removeAttribute('data-admin-design');
      root.removeAttribute('data-theme');
    };
  }, [isAdmin]);
}
